@if (!rawDatasource()) {
  <div class="my-6 flex justify-center"><ISpinner /></div>
} @else if (rawDatasource()!.length === 0) {
  <div class="mt-8">
    <IEmptyState
      title="No Strategy"
      description="You have no strategy for the selected account and marketplace"
      ctaLabel="Create a Strategy"
      ctaIcon="add"
      ctaRoute="./create"
      [ctaDisabled]="isReadonly()"
    />
  </div>
} @else {
  <IDataTable
    [datasource]="dataSource"
    searchPlaceholder="strategy-list.search_by_strategy_name_or_asin"
    *transloco="let t"
  >
    @if (filters.length > 0) {
      <app-compact-filter iDataTablePrefix [filters]="filters" (filterChange)="onFilterChange($event)" />
    }
    <div class="flex items-center gap-2" iDataTableSuffix>
      @if (campaignType === CampaignType.DSP) {
        <a iButton routerLink="../blacklist" variant="secondary">
          {{ t("strategy-list.inventory_blacklist") }}
        </a>
      }
      @if (selectedStrategies().size > 0) {
        <button
          iButton
          testId="delete-strategies-button"
          variant="destructive"
          [disabled]="isReadonly()"
          [loading]="deleteStrategiesLoading()"
          (click)="deleteSelectedStrategies()"
        >
          <IIcon name="trash" />
          {{ deleteStrategiesLabel() }}
        </button>
      }
      <a iButton testId="create-strategy-button" [class.disabled]="isReadonly()" routerLink="./create">
        <IIcon name="plus" />
        {{ t("sd-strategy-creation.create_strategy") }}
      </a>
      @if (campaignType !== CampaignType.DSP) {
        <button iButton [iDropdownMenuTrigger]="dropdownMenu" variant="secondary" placement="bottom-end" size="icon-sm">
          <IIcon name="ellipsis" />
        </button>

        <ng-template #dropdownMenu>
          <IDropdownMenu>
            <button iDropdownMenuItem (click)="onExportStrategies()">
              <IIcon name="upload" />
              {{ t("common.export") }}
            </button>
            @if (campaignType !== CampaignType.SB && !isReadonly()) {
              <button iDropdownMenuItem (click)="bulkImportStrategies()">
                <IIcon name="import" />
                {{ t("common.import") }}
              </button>
            }
            <IDropdownMenuSeparator />
            <button iDropdownMenuItem (click)="pushBidderRun()" [disabled]="isReadonly()">
              <IIcon name="arrowUp" />
              {{ t("strategy-list.push_bidder_run") }}
            </button>
            @if (lastBidderRun()) {
              <IDropdownMenuSeparator />
              <div class="px-2 pb-0.5 text-sm">
                <div class="text-sm text-gray-400">{{ t("strategy-list.last_run") }}</div>

                <div class="font-medium tracking-tight text-gray-600">
                  {{ lastBidderRun()?.lastBidderStartLocal | date: "long" : undefined : locale() }}
                </div>
              </div>
            }
          </IDropdownMenu>
        </ng-template>
      }
    </div>
    <table iTable>
      <thead iTableHead>
        <tr iTableRow>
          <th></th>
          <th iTableTh>
            {{ t("common.strategy") }}
          </th>
          <th iTableTh>
            {{ t("common.target") }}
          </th>
          @for (column of gridColumns; track column) {
            <th iTableTh>
              {{ t(strategyGridColumnsTitles[column]) }}
            </th>
          }
          <th iTableTh></th>
        </tr>
      </thead>
      <tbody>
        @for (strategy of dataSource.data(); track strategy.strategyId) {
          <tr
            iTableRow
            app-strategy-grid-line
            [strategy]="strategy"
            [gridColumns]="gridColumns"
            [brands]="brands()"
            [segmentIndex]="segmentIndex()"
            [isSelected]="selectedStrategies().has(strategy)"
            (selectedStrategy)="selectStrategy(strategy)"
          ></tr>
        } @empty {
          <tr class="text-center text-sm text-gray-700">
            <td colspan="100" class="h-18">
              {{ t("strategy-grid.no_strategy_matching_your_search") }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </IDataTable>
}
